import { Component, OnInit, inject, signal, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectModule as DropdownModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputGroupModule } from 'primeng/inputgroup';
import { SplitButton, SplitButtonModule } from 'primeng/splitbutton';
import { MenuItem } from 'primeng/api';
import { TokenService } from '../../services';
import { ExportFileTypeEnum, exportTypes } from '../../../shared';

@Component({
  selector: 'app-export-button',
  templateUrl: './export-button.component.html',
  imports: [CommonModule, DropdownModule, FormsModule, ButtonModule, InputGroupModule, SplitButtonModule],
})
export class ExportButtonComponent implements OnInit {
  private tokenService = inject(TokenService);

  exportFormat = output<ExportFileTypeEnum>();
  onlyForAdmin = input<boolean>(true);
  styleClass = input<string>();

  public show = signal<boolean>(false);
  public items: MenuItem[] = [];

  ngOnInit() {
    this.items = exportTypes(this.handleExport.bind(this));
    this.updateVisibility();
  }

  private updateVisibility() {
    this.show.set(this.tokenService.isAdmin() || !this.onlyForAdmin());
  }

  handleExport(format: ExportFileTypeEnum) {
    this.exportFormat.emit(format);
  }

  openSplitButton(splitButton: SplitButton, eventClick: MouseEvent): void {
    setTimeout(() => {
      splitButton.onDropdownButtonClick(eventClick);
    }, 0);
  }
}
